module.exports = __webpack_public_path__ + "static/transactions-03c5dd89b9aff881b87313b0eaf9af64.png";